import api from '@/request/api'
import {Dialog, Toast} from 'vant';
import router from '@/router/index'
import Vue from 'vue';
import store from '@/store/index'
import {
    printOrderDetail,
    printOrderFinish,
    printDish,
    printDeskCode,
    printDaily,
    printReturnDish,
    printLodopTemp,
    labelPrintLodopTemp
} from './winPrint'
import {
    checkTagConnect,
    checkUsbConnect,
    connectAuto,
    connectAutoLabel,
    connectAutoLabelBlue,
    deviceConnectClose,
    getBleConnectStatus,
    isPrinterSupported
} from './outPrint';

const formatNumber_y = n => {
    n = n.toString()
    return n[1] ? n : '0' + n
}

export function formatTimeWitchLine(date) {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    return [year, month, day].map(formatNumber_y).join('-')
}

export function formatTime(date, fmt) {
    let o = {
        "M+": date.getMonth() + 1,                 //月份
        "d+": date.getDate(),                    //日
        "h+": date.getHours(),                   //小时
        "m+": date.getMinutes(),                 //分
        "s+": date.getSeconds(),                 //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
}

export function tagKiller(msg) {
    if (msg) {
        var msg = msg.replace(/<\/?[^>]*>/g, ""); //去除HTML Tag
        msg = msg.replace(/[|]*\n/, ""); //去除行尾空格
        msg = msg.replace(/&nbsp;/gi, ""); //去掉nbsp
        return msg;
    }
}

export function printTest(res, type) {
    //console.log('打印的原始数据---', res);
    // 点菜单菜品数据处理
    var dishList = res.data.data.dishList ? JSON.parse(JSON.stringify(res.data.data.dishList)) : [];
    let addDishList = dishList.filter(item => {
        // console.log(item.dishName.indexOf("加单"))
        return item.dishName.indexOf("(加单)") >= 0 || item.dishName.indexOf("（加单）") >= 0;
    });
    // console.log(addDishList)
    dishList = dishList.filter(item => {
        return item.dishName.indexOf("(加单)") < 0 && item.dishName.indexOf("（加单）") < 0;
    });
    // console.log(dishList)
    // console.log('addDishList', addDishList)
    addDishList.forEach(item => {
        // 中文替换的有问题，所以用Unicode编码了
        // “（加单）单人餐”替换成“人餐”了
        item.dishName = item.dishName
            .replace(/\u0028\u52a0\u5355\u0029/g, "")
            .replace(/\uff08\u52a0\u5355\uff09/g, "");
    });
    // console.log('addDishList', addDishList)
    let printDishList = [];
    let addprintDishList = [];
    console.log('dishList', dishList);
    dishList.forEach((item, index) => {
        // console.log('item', item);
        let oneLineText = [
            item.serialNumber, //0编号
            item.dishName,  // 1菜品名称
            item.num, // 2菜品数量
            parseFloat(item.count).toFixed(store.state.digits), // 3小计
            item.price.toString(), // 4单价
            item.spec_attr_name || '', //5规格
            item.discount_food == 0 ? '0' : '1',  // 6是否参与打折
            item.food_spec_fake == 1 ? '1' : '0', // 7是否选择了规格
            item.type, // 8菜品类型
        ];
        if (item.type == 3 && item.spec_json) {
            oneLineText.push(JSON.stringify(item.spec_json.setmeal_list)); // 9
        }
        printDishList.push(oneLineText);
    });
    addDishList.forEach((item, index) => {
        // console.log('addDishList--', item);
        let oneLineText = [
            item.serialNumber,
            item.dishName,
            item.num,
            parseFloat(item.count).toFixed(store.state.digits),
            item.price.toString(),
            item.spec_attr_name || '',
            item.discount_food == 0 ? '0' : '1',
            item.food_spec_fake == 1 ? '1' : '0',
            item.type, // 菜品类型
        ];
        if (item.type == 3 && item.spec_json) {
            oneLineText.push(JSON.stringify(item.spec_json.setmeal_list));
        }
        addprintDishList.push(oneLineText);
        // console.log('addprintDishList', addprintDishList)
    });
    // console.log(printDishList, 'printDishList')

    let ob1 = JSON.parse(JSON.stringify(res.data.data));
    // 后厨做菜单数据处理
    let foodsList = [];
    // console.log('res.data.data.meal_type------', res.data.data.meal_type);
    if (res.data.data.meal_type == 1 && !res.data.data.print_type) {
        let foods = res.data.food_list ? JSON.parse(JSON.stringify(res.data.food_list)) : [];
        foods.forEach(element => {
            if (element.type == 3 && type == 3) {
                if (element.spec_json) {
                    const info = element.spec_json.setmeal_list;
                    for (let m = 0; m < info.length; m++) {
                        const food = info[m];
                        let food_obj = Object.assign({}, food, {
                            food_name: food.name,
                            food_num: food.num * element.food_num,
                            spec_attr_name: food.attr || '',
                            food_spec_fake: food.food_spec_fake == 1 ? '1' : '0', // 是否选择了规格
                            is_setmeal: 1, // 是套餐内的菜品
                        })
                        foodsList.push(food_obj);
                    }
                }
            } else {
                foodsList.push(element);
            }
        });
    } else if (res.data.data.meal_type == 2 || (res.data.data.print_type == 1 || res.data.data.print_type == 2)) {
        let dl = []
        let d = res.data.data.dishList ? JSON.parse(JSON.stringify(res.data.data.dishList)) : [];
        d.forEach((item, index) => {
            // console.log(item, 'dddddd');
            if (item.type == 3 && type == 3 && item.spec_json) {
                const info = item.spec_json.setmeal_list;
                // console.log('aaa', info);
                for (let j = 0; j < info.length; j++) {
                    const food = info[j];
                    let food_obj = Object.assign({}, food, {
                        food_name: food.name.replace(/\u0028\u52a0\u5355\u0029/g, "")
                            .replace(/\uff08\u52a0\u5355\uff09/g, ""),
                        food_num: (food.num * item.num).toString(),
                        spec_attr_name: food.attr || '',
                        food_spec_fake: food.food_spec_fake == 1 ? '1' : '0', // 是否选择了规格
                        is_setmeal: 1, // 是套餐内的菜品
                    })
                    dl.push(food_obj);
                }
            } else {
                item.dishName = item.dishName
                    .replace(/\u0028\u52a0\u5355\u0029/g, "")
                    .replace(/\uff08\u52a0\u5355\uff09/g, "");
                let oneLineText = Object.assign(item, {
                    food_name: item.dishName,
                    food_num: item.num.toString(),
                    spec_attr_name: item.spec_attr_name || '',
                    food_spec_fake: item.food_spec_fake == 1 ? '1' : '0',
                });
                dl.push(oneLineText);
            }
        });
        foodsList = dl;
    }
    //console.log('foodsList:::::::', foodsList);
    let print_menu = res.data.print_menu ? res.data.print_menu * 1 : 0;
    let print_receipt = res.data.print_receipt ? res.data.print_receipt * 1 : 0;
    let print_food = res.data.print_food ? res.data.print_food * 1 : 0;
    let hc_print_food = res.data.hc_print_food ? res.data.hc_print_food * 1 : 0;
    let print_return_menu = res.data.print_return_menu ? res.data.print_return_menu * 1 : 0;
    let print_pass_menu = res.data.print_pass_menu ? res.data.print_pass_menu * 1 : 0;
    let one_dis = 'one_dis';
    if (!res.data.data.print_type) {
        one_dis = res.data.one_dis ? res.data.one_dis : 'one_dis';
    } else {
        one_dis = res.data.data.one_dis ? res.data.data.one_dis : 'one_dis';
    }
    let merge_print = '2';
    if (res.data.merge_print) {
        merge_print = res.data.merge_print;
    } else if (res.data.data && res.data.data.merge_print) {
        merge_print = res.data.data.merge_print;
    } else {
        merge_print = '2';
    }
    // 标签单打印数据处理 is_tag_print==1
    let labelFoods = [];
    let beforeLableFoods = [];
    if (res.data.data.meal_type == 1 && !res.data.data.print_type) {
        beforeLableFoods = res.data.food_tag_list ? JSON.parse(JSON.stringify(res.data.food_tag_list)) : [];
        for (let i = 0; i < beforeLableFoods.length; i++) {
            const element = beforeLableFoods[i];
            if ((element.type == 1 || element.type == 2) && element.is_tag_print == 1) {
                let oneLineText = Object.assign(element, {
                    spec_attr_name: element.spec_attr_name || '',
                    food_spec_fake: element.food_spec_fake == 1 ? '1' : '0',
                });
                labelFoods.push(oneLineText);
            } else if (element.type == 3) { // 套餐内商品处理
                if (element.spec_json) {
                    const info = element.spec_json.setmeal_list;
                    for (let n = 0; n < info.length; n++) {
                        const food = info[n];
                        if (food.is_tag_print == 1) {
                            let oneLineText = Object.assign(food, {
                                food_name: food.name,
                                food_num: (food.num * element.food_num).toString(),
                                spec_attr_name: food.attr || '',
                                food_spec_fake: food.food_spec_fake == 1 ? '1' : '0',
                                is_setmeal: 1, // 是套餐内的菜品
                            });
                            labelFoods.push(oneLineText);
                        }
                    }
                }
            }
        }
    } else if (res.data.data.meal_type == 2 || (res.data.data.print_type == 1 || res.data.data.print_type == 2)) {
        beforeLableFoods = res.data.data.dishTagList ? JSON.parse(JSON.stringify(res.data.data.dishTagList)) : [];
        beforeLableFoods.forEach((item, index) => {
            if ((item.type == 1 || item.type == 2) && item.is_tag_print == 1) {
                item.dishName = item.dishName
                    .replace(/\u0028\u52a0\u5355\u0029/g, "")
                    .replace(/\uff08\u52a0\u5355\uff09/g, "");
                let oneLineText = Object.assign(item, {
                    food_name: item.dishName,
                    food_num: item.num.toString(),
                    spec_attr_name: item.spec_attr_name || '',
                    is_tag_print: item.is_tag_print || '0',
                    food_spec_fake: item.food_spec_fake == 1 ? '1' : '0',
                });
                labelFoods.push(oneLineText);
            } else if (item.type == 3) { // 套餐内商品处理
                if (item.spec_json) {
                    const info = item.spec_json.setmeal_list;
                    for (let n = 0; n < info.length; n++) {
                        const food = info[n];
                        if (food.is_tag_print == 1) {
                            let oneLineText = Object.assign(food, {
                                food_name: food.name.replace(/\u0028\u52a0\u5355\u0029/g, "")
                                    .replace(/\uff08\u52a0\u5355\uff09/g, ""),
                                food_num: (food.num * item.num).toString(),
                                spec_attr_name: food.attr || '',
                                is_tag_print: food.is_tag_print || '0',
                                food_spec_fake: food.food_spec_fake == 1 ? '1' : '0',
                                is_setmeal: 1, // 是套餐内的菜品
                            });
                            labelFoods.push(oneLineText);
                        }
                    }
                }
            }
        });
    }
    // 订单备注处理
    if (res.data.data.remark && res.data.data.remark != '' && typeof res.data.data.remark == 'object' && res.data.data.remark.length > 0) {
        let remarkArr = [];
        res.data.data.remark.forEach(element => {
            if (element.order_remark && element.order_remark != '') {
                remarkArr.push(element.order_remark);
            }
        });
        ob1['remark'] = remarkArr.join(';');
    }
    if (labelFoods.length > 0) {
        ob1['labelSize'] = labelFoods[0].tag_size || 50;
    }
    let newObj1 = Object.assign(
        ob1,
        {type: type},
        {printDishList: printDishList},
        {addprintDishList: addprintDishList},
        {foodsList: foodsList},
        {print_menu: print_menu},
        {print_receipt: print_receipt},
        {print_food: print_food},
        {hc_print_food: hc_print_food},
        {print_return_menu: print_return_menu},
        {print_pass_menu: print_pass_menu},
        {one_dis: one_dis},
        {isReprint: res.isReprint ? res.isReprint : 0}, // 是否补打
        {isMerge: merge_print}, // 后厨做菜单是否合并
        {labelFoods: labelFoods}, // 需要打印标签制作单的菜品列表
    );
    console.log('newObj1----------', newObj1);
    return newObj1

}

// 退菜单数据处理 returnNum：退的数量 returnNumStr：数量+单位
export function printTestReturnMenu(orderDetail, food, returnNum, returnNumStr, type, reason) {
    // console.log(orderDetail, food, returnNum, returnNumStr, type, reason);
    let shopdata = {
        desk_num: orderDetail.desk_num_name || orderDetail.desk_num,
       // return_time: orderDetail.return_time || '',  //2024-7-13
        orderNum: orderDetail.order_num,
        ip: food.ip,
        cloud_sn: food.cloud_sn,
        size: food.size,
        return_time: food.return_time || '',
        shopName: store.getters.shop.name,
    }
    if (food.ip && food.ip != '') {
        shopdata['hcPrinterType'] = '4';
    }
    if (food.cloud_sn && food.cloud_sn != '') {
        shopdata['hcPrinterType'] = food.printer_type || '';
    }
    let foodsdata = []
    foodsdata.push({
        food_name: food.food_name,
        return_num: returnNumStr,
        price: food.price,
        totalPrice: parseFloat((food.price * returnNum * 1000) / 1000).toFixed(store.state.digits),
        spec_attr_name: food.spec_attr_name || '',
        type: food.food_type,
        food_spec_fake: food.food_spec_fake == 1 ? '1' : '0',
        c_setmeal_list: food.c_setmeal_list || [],
    })
    let newObjData = Object.assign(
        shopdata,
        {
            type: type,
            returnFoodsList: JSON.stringify(foodsdata),
            returnTotalPrice: parseFloat((food.price * returnNum * 1000) / 1000).toFixed(store.state.digits),
        },
        {reason: reason},
    )
    // console.log('newObjData', newObjData);
    return newObjData
}

// 快餐后厨打印做菜单处理
export function printTestMenu(res, type) {
    // console.log('##########', res.data.data, type);
    let ob1 = JSON.parse(JSON.stringify(res.data.data));
    let foods = [];
    let dl = []
    let d = res.data.data.dishList ? JSON.parse(JSON.stringify(res.data.data.dishList)) : [];
    d.forEach((item, index) => {
        if (item.type == 3 && type == 3) {
            const info = item.spec_json.setmeal_list;
            for (let j = 0; j < info.length; j++) {
                const food = info[j];
                let food_obj = Object.assign({}, food, {
                    food_name: food.name,
                    food_num: (food.num * item.num).toString(),
                    spec_attr_name: food.attr || '',
                    food_spec_fake: food.food_spec_fake == 1 ? '1' : '0', // 是否选择了规格
                    is_setmeal: 1, // 是套餐内的菜品
                })
                dl.push(food_obj);
            }
        } else if (item.type == 1 || item.type == 2) {
            let oneLineText = Object.assign(item, {
                food_name: item.dishName,
                food_num: item.num.toString(),
                spec_attr_name: item.spec_attr_name || '',
                price: item.price.toString(),
                food_spec_fake: item.food_spec_fake == 1 ? '1' : '0',
            });
            dl.push(oneLineText);
        }
    });
    foods = dl;
    let merge_print = '2';
    if (res.data.merge_print) {
        merge_print = res.data.merge_print;
    } else if (res.data.data && res.data.data.merge_print) {
        merge_print = res.data.data.merge_print;
    } else {
        merge_print = '2';
    }
    let labelFoods = [];
    let beforeLableFoods = res.data.data.dishTagList ? JSON.parse(JSON.stringify(res.data.data.dishTagList)) : [];
    ;
    for (let i = 0; i < beforeLableFoods.length; i++) {
        const element = beforeLableFoods[i];
        if ((element.type == 1 || element.type == 2) && element.is_tag_print == 1) {
            let oneLineText = Object.assign(element, {
                food_name: element.dishName,
                food_num: element.num.toString(),
                spec_attr_name: element.spec_attr_name || '',
                price: element.price.toString(),
                food_spec_fake: element.food_spec_fake == 1 ? '1' : '0',
            });
            labelFoods.push(oneLineText);
        } else if (element.type == 3 && element.spec_json) {
            const info = element.spec_json.setmeal_list;
            for (let n = 0; n < info.length; n++) {
                const food = info[n];
                if (food.is_tag_print == 1) {
                    let oneLineText = Object.assign(food, {
                        food_name: food.name,
                        food_num: (food.num * element.num).toString(),
                        spec_attr_name: food.attr || '',
                        price: food.price.toString(),
                        food_spec_fake: food.food_spec_fake == 1 ? '1' : '0',
                        is_setmeal: 1, // 是套餐内的菜品
                    });
                    labelFoods.push(oneLineText);
                }
            }
        }
    }
    if (labelFoods.length > 0) {
        ob1['labelSize'] = labelFoods[0].tag_size || 50;
    }
    if (res.data.data.remark && res.data.data.remark != '' && typeof res.data.data.remark == 'object' && res.data.data.remark.length > 0) {
        let remarkArr = [];
        res.data.data.remark.forEach(element => {
            if (element.order_remark && element.order_remark != '') {
                remarkArr.push(element.order_remark);
            }
        });
        ob1['remark'] = remarkArr.join(';');
    }
    let obj = Object.assign(
        ob1,
        {type: type},
        {printDishList: []},
        {addprintDishList: []},
        {foodsList: foods},
        {isMerge: merge_print}, // 后厨做菜单是否合并
        {labelFoods: labelFoods}, // 需要打印标签制作单的菜品
    )
    return obj;
}

// 日报打印数据处理
export function printTestDaily(data, type) {
    const dailyData = data.data;
    // console.log('dailyData', dailyData);
    let p_data = {};
    p_data['fir'] = [
        {label: '营业实收:', value: parseFloat(dailyData.day_income).toFixed(store.state.digits).toString(),},
        {label: '订单实收：', value: parseFloat(dailyData.sale_amount).toFixed(store.state.digits).toString(),},
        {label: '储值实收：', value: parseFloat(dailyData.recharge_income).toFixed(store.state.digits).toString(),},
        {label: '不计入实收：', value: `-${parseFloat(dailyData.no_count_act).toFixed(store.state.digits).toString()}`,},
    ]
    p_data['sec'] = [
        {label: '订单实收:', value: parseFloat(dailyData.sale_amount).toFixed(store.state.digits).toString(),},
        // { label: '应收金额：', value: parseFloat(dailyData.day_discount).toFixed(store.state.digits).toString(), },
        {label: '退款金额：', value: `-${parseFloat(dailyData.return_amount).toFixed(store.state.digits).toString()}`,},
        {label: '订单数量：', value: `${dailyData.order_count || 0}单`,},
        {label: '退款笔数：', value: `${dailyData.return_num || 0}笔`,},
    ]
    p_data['the'] = [
        {label: '储值实收:', value: parseFloat(dailyData.recharge_income).toFixed(store.state.digits).toString(),},
        {label: '储值订单：', value: `${dailyData.recharge_num || 0}单`,},
        {label: '赠送金额：', value: parseFloat(dailyData.give_amount).toFixed(store.state.digits).toString(),},
    ]
    p_data['fourth'] = [
        {label: '订单收退款构成'},
    ]
    if (dailyData.xj_amount > 0 || dailyData.xj_return_amount > 0) {
        p_data['fourth'].push({
            label: '现金：',
            middleVal: `收${parseFloat(dailyData.xj_amount).toFixed(store.state.digits).toString()}，`,
            value: `退${parseFloat(dailyData.xj_return_amount).toFixed(store.state.digits).toString()}`,
        })
    }
    if (dailyData.hy_amount > 0 || dailyData.hy_return_amount > 0) {
        p_data['fourth'].push({
            label: '会员余额：',
            middleVal: `收${parseFloat(dailyData.hy_amount).toFixed(store.state.digits).toString()}，`,
            value: `退${parseFloat(dailyData.hy_return_amount).toFixed(store.state.digits).toString()}`,
        })
    }
    if (dailyData.wx_amount > 0 || dailyData.wx_return_amount > 0) {
        p_data['fourth'].push({
            label: '微信：',
            middleVal: `收${parseFloat(dailyData.wx_amount).toFixed(store.state.digits).toString()}，`,
            value: `退${parseFloat(dailyData.wx_return_amount).toFixed(store.state.digits).toString()}`,
        })
    }
    if (dailyData.zfb_amount > 0 || dailyData.zfb_return_amount > 0) {
        p_data['fourth'].push({
            label: '支付宝：',
            middleVal: `收${parseFloat(dailyData.zfb_amount).toFixed(store.state.digits).toString()}，`,
            value: `退${parseFloat(dailyData.zfb_return_amount).toFixed(store.state.digits).toString()}`,
        })
    }
    if (dailyData.ysf_amount > 0 || dailyData.ysf_return_amount > 0) {
        p_data['fourth'].push({
            label: '云闪付：',
            middleVal: `收${parseFloat(dailyData.ysf_amount).toFixed(store.state.digits).toString()}，`,
            value: `退${parseFloat(dailyData.ysf_return_amount).toFixed(store.state.digits).toString()}`,
        })
    }
    let daily = JSON.stringify(p_data);
    let obj = Object.assign(
        dailyData,
        {type: type},
        {daily: daily}
    )
    return obj;
}


// 判断是否是在APP内打开，dzbdcAgent是在config.xml中进行配置，具体查看cordova相关配置
export async function _isInApp() {
    let device = '';
    let flag_android = navigator.userAgent.match(/dzbdcAgent/g) // cordova安卓打包,dzbdcAgent是在config.xml中进行配置
    // console.log('flag_android:', flag_android);
    let flag_ios = navigator.userAgent.match(/dzbdcIOS/g) // cordova IOS打包,dzbdcIOS是在config.xml中进行配置
    // console.log('flag_ios:', flag_ios);
    if (flag_android) {
        // console.log('环境--Android移动端');
        const supported = await isPrinterSupported(); // 检查是否支持内置打印，如果code=1，就定义为mt_android（美团收银机）
        // console.log('supported----', supported);
        if (supported && supported.code == 1) {
            device = 'mt_android';
        } else {
            device = 'android';
        }
    } else if (flag_ios) {
        // console.log('环境--IOS移动端');
        device = 'ios';
    } else {
        device = 'windows';
    }
    // device = 'android';
    return device
}

export function randomString(e, t) {
    e = e || 32;
    // console.log(t);
    let a = t.length,
        n = "";
    for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
    return n
}

// 本地、测试、体验
export function _typeofEnv() {
    let hostname = location.hostname;
    // console.log('location--', location);
    let type = '';
    if (!hostname || hostname == '') {
        type = 'app'
    } else if (hostname == 'localhost') { // 本地
        type = 'local';
    } else if (hostname == 'demo.diancan.dianzhangbao.net') { // 体验版
        type = 'experience';
    } else if (hostname == 'dc.pc.dianzhangbao.net') { // Windows版指向的正式地址
        type = 'exe';
    } else if (hostname == 'takingorder.devicehall.view.fengxl.com') { // 测试
        type = 'dev';
    } else {
        type = 'dev';
    }
    return type;
}

// 获取当前指定前几天的日期
export function getBeforeDate(days) {
    const now = new Date().getTime();
    const ago = now - 86400000 * days;//一天的毫秒数为86400000
    let agoData = new Date(ago);
    return agoData;
}

export function netPrintSend(data) {
    console.log('////////////////////////', data);
    switch (data.type) { // 15桌码
        case 1:
            data.type = 12;
            break;
        case 2:
            data.type = 11; // 点餐详情
            break;
        case 3:
            data.type = 13; // 做菜单
            data.f_type = localStorage.is_printcc == 1 ? '1' : '2';
            break;
        case 4:
            data.type = 14; // 结账单
            data.code_type = localStorage.is_printfp == 1 ? '1' : '2';
            break;
    }
    // console.log('网络打印机打印信息：', data.type, JSON.stringify(data));
    let p_data = new FormData();
    if (data.type == 28 || data.type == 29) {
        for (const key in data) {
            if (Object.hasOwnProperty.call(data, key)) {
                const element = data[key];
                if (key == 'data') {
                    p_data.append(key, JSON.stringify(element));
                } else {
                    p_data.append(key, element);
                }
            }
        }
    } else {
        for (const key in data) {
            if (Object.hasOwnProperty.call(data, key)) {
                const element = data[key];
                if (key == 'printDishList' || key == 'addprintDishList' || key == 'dishList' || key == 'foodsList') {
                    p_data.append(key, JSON.stringify(element));
                } else if (key == 'returnFoodsList') {
                    p_data.append(key, typeof element != 'string' ? JSON.stringify(element) : element);
                } else {
                    p_data.append(key, element);
                }
            }
        }
    }
    // console.log('p_data:', p_data);
    return new Promise((resolve, reject) => {
        // resolve();
        api.netPrint(p_data).then(res_ => {
            if (res_.code == 1) {
                resolve(res_);
            } else {
                reject(res_);
            }
        }).catch(() => {
            Toast('打印失败，未连接到打印机')
            reject();
        });
    })
}

export function winPrintSend(data) {
    // console.log('打印机打印信息：', data.type, JSON.stringify(data));
    return new Promise((resolve, reject) => {
        if (data.type != 15 && data.type != 25) {
            printLodopTemp(data).then(res => {
                resolve();
            });
        }
        // 点菜单
        // if (data.type == 2) {
        //   printOrderDetail(data).then(res => {
        //     resolve();
        //   });
        // }
        // // 结账单
        // if (data.type == 4) {
        //   printOrderFinish(data).then(res => {
        //     resolve();
        //   });
        // }
        // // 做菜单
        // if (data.type == 3) {
        //   printDish(data).then(res => {
        //     resolve();
        //   });
        // }
        // // 日报
        // if (data.type == 21) {
        //   printDaily(data).then(res => {
        //     resolve();
        //   })
        // }
        // 桌码
        if (data.type == 15) {
            printDeskCode(data).then(res => {
                resolve();
            });
        }
        // // 前台退菜单
        // if (data.type == 18) {
        //   printReturnDish(data).then(res => {
        //     resolve();
        //   });
        // }
        // 标签制作单
        if (data.type == 25) {
            for (let i = 0; i < data.labelFoods.length; i++) {
                const element = data.labelFoods[i];
                if (element.type == 1 || element.food_type == 1) {
                    for (let j = 0; j < element.food_num; j++) {
                        const new_data = Object.assign({}, data);
                        new_data['labelFoods'] = [];
                        const food = Object.assign({}, element);
                        new_data['food'] = food;
                        new_data['printer_name'] = store.state.tagPrinter[0].printer_name;
                        labelPrintLodopTemp(new_data).then(res => {
                            resolve();
                        });
                    }
                } else {
                    const new_data = Object.assign({}, data);
                    new_data['labelFoods'] = [];
                    const food = Object.assign({}, element);
                    new_data['food'] = food;
                    new_data['printer_name'] = store.state.tagPrinter[0].printer_name;
                    labelPrintLodopTemp(new_data).then(res => {
                        resolve();
                    });
                }
            }
        }
    })
}

export function menuPrintFif(data) {
    // console.log('-------', data.foodsList);
    let ipArr = [];
    let foodlist = data.foodsList;
    for (let i = 0; i < foodlist.length; i++) {
        const element = foodlist[i];
        // element.cloud_sn = element.cloud_sn && element.cloud_sn > 0 ? element.cloud_sn : '';
        if (element.ip && element.ip != '') {
            if (ipArr.findIndex(e => e.ip == element.ip) == -1) {
                const fdata = Object.assign({}, data, {
                    ip: element.ip,
                    size: element.size,
                    foodsList: [],
                    print_id: element.shop_print_id || 0,
                    printtest: element.printtest || '',
                    hcPrinterType: '4',
                })
                data.foodsList = [];
                ipArr.push(fdata);
            }
        } else if (element.cloud_sn && element.cloud_sn != '' && element.cloud_sn > 0) {
            if (ipArr.findIndex(e => e.cloud_sn == element.cloud_sn) == -1) {
                const fdata = Object.assign({}, data, {
                    cloud_sn: element.cloud_sn,
                    size: element.size,
                    foodsList: [],
                    hcPrinterType: element.printer_type || '',
                })
                data.foodsList = [];
                ipArr.push(fdata);
            }
        } else {

        }
    }
    for (let j = 0; j < foodlist.length; j++) {
        const ele = foodlist[j];
        for (let i = 0; i < ipArr.length; i++) {
            const element = ipArr[i];
            if (ele.ip && element.ip == ele.ip) {
                element.foodsList.push(ele)
            } else if (ele.cloud_sn && ele.cloud_sn > 0 && element.cloud_sn == ele.cloud_sn) {
                element.foodsList.push(ele)
            } else {

            }
        }
    }
    return ipArr;
}

export function checkPrintType() {
    if (!store.state.deviceMac || store.state.deviceMac == '') {
        return;
    }
    return new Promise((resolve, reject) => {
        api.printerList({
            device_mac: store.state.deviceMac
        }).then(async res => {
            if (res.code == 1) {
                let front_printer = res.data.front_printer || [];
                let hc_printer = res.data.back_printer || [];
                let tag_printer = res.data.tag_printer || [];
                // console.log('-----', tag_printer);
                store.commit('updateTagPrinter', tag_printer);
                const index = front_printer.findIndex(
                    // (e) => e.bind_status == 1
                    (e) => e.is_bind_device == 1
                );
                // console.log('前台打印机', front_printer[index]);
                if (index > -1) {
                    store.commit('updateQtPrinter', front_printer[index]);
                    let print_type = getPrinterType(front_printer[index].printer_type.toString(), 1)
                    localStorage.setItem('printType', print_type)
                    localStorage.setItem('qiantaiPrintSize', front_printer[index].size)
                    localStorage.setItem('printer_id', front_printer[index].id || 0);
                    if (print_type == 4) { // 网络打印机
                        localStorage.setItem('qiantaiPrintIp', front_printer[index].ip)
                    }

                    if (print_type == '6') {
                        localStorage.setItem('qtDeviceSN', front_printer[index].cloud_sn)
                        localStorage.setItem('qtDeviceKey', front_printer[index].cloud_key)
                    }

                    if (print_type == '11') {
                        localStorage.setItem('qtDeviceSN', front_printer[index].cloud_sn)
                    }

                    if (print_type == 1 || print_type == 3) {
                        localStorage.setItem('printer_name', front_printer[index].printer_name)
                        localStorage.setItem('printer_address', front_printer[index].printer_address)
                        connectAuto(front_printer[index]);
                    }
                } else {
                    // console.log('未设置前台打印机');
                    localStorage.removeItem('printType')
                    localStorage.removeItem('qiantaiPrintIp')
                    localStorage.removeItem('qiantaiPrintSize')
                    localStorage.removeItem('printer_name')
                    localStorage.removeItem('printer_address')
                    localStorage.removeItem('printer_id');
                    localStorage.removeItem('qtDeviceSN');
                    localStorage.removeItem('qtDeviceKey');
                }
                // console.log('checkPrintType---===', type);
                resolve(res);
            } else {
                // Toast('未设置打印机');
                localStorage.removeItem('printType')
                localStorage.removeItem('qiantaiPrintIp')
                localStorage.removeItem('qiantaiPrintSize')
                localStorage.removeItem('printer_name')
                localStorage.removeItem('printer_address')
                localStorage.removeItem('printer_id');
                localStorage.removeItem('qtDeviceSN');
                localStorage.removeItem('qtDeviceKey');
                resolve(res);
            }
        }).catch(() => {
            resolve();
        })
    })
}

export async function checkLabelPrint(str) {
    const tag_printer_list = store.state.tagPrinter;
    // console.log('tag_printer_list', tag_printer_list, str);
    setTimeout(async () => {
        if (tag_printer_list.length > 0) {
            const tag_printer = tag_printer_list[0];
            const printer_type = getPrinterType(tag_printer.printer_type.toString(), 1, 3);
            if (printer_type == 7) {
                const tagRes = await checkTagConnect();
                // console.log('tagRes', tagRes);
                if (tagRes.code != 1) {
                    connectAutoLabel('usb', tag_printer); // 目前安卓只有USB
                }
            } else if (printer_type == 12) { // 蓝牙
                const tagRes = await checkTagConnect();
                console.log('tagRes', tagRes);
                if (tagRes.code != 1) {
                    connectAutoLabel('bluetooth', tag_printer);
                }
            }
        }
    }, 500);
}

/**
 * 由于前端与后台的打印机类型值不同，进行转换
 * @param type 打印机类型
 * @param action 1后台转前端，2前端转后台
 * @param printer 设置的打印机类型，1前台打印机，2后厨打印机，3标签打印机
 */
export function getPrinterType(type, action, printer) {
    type = type.toString();
    if (action == 2) { // 前端转后台
        // 前端定义的打印机类型 2：SUNMI打印机  4：网络打印机  3：蓝牙打印机 1：USB打印机 5：驱动打印机   6：云打印机
        // 7：USB打印机-标签打印机安卓 8：驱动打印机-标签打印机Windows 9：蓝牙打印机-标签打印机IOS 10：美团内置打印机
        // 11：佳博云打印机 12蓝牙打印机-标签打印机安卓
        // 传给后台的打印机类型 1，summi打印机  2，网络打印机  3，蓝牙打印机 4，USB打印机 5，电子秤打印机，6，云打印机 7，佳博云打印机
        let tp = '1';
        switch (type) {
            case '2':
                tp = '1';
                break;
            case '4':
                tp = '2';
                break;
            case '1':
                tp = '4';
                break;
            case '7':
                tp = '4';
                break;
            case '8':
                tp = '5';
                break;
            case '9':
                tp = '3';
                break;
            case '11':
                tp = '7';
                break;
            default:
                tp = type;
                break;
        }
        return tp;
    } else { // 后台转前端
        // 传给后台的打印机类型 1，summi打印机  2，网络打印机  3，蓝牙打印机 4，USB打印机 5，电子秤打印机，6 云打印机 7佳博云打印机
        // 前端定义的打印机类型 2：SUNMI打印机  4：网络打印机  3蓝牙打印机 1USB打印机 5：驱动打印机   6：云打印机
        // 7：USB打印机-标签打印机安卓 8：驱动打印机-标签打印机Windows 9：蓝牙打印机-标签打印机IOS 10：美团内置打印机
        // 11佳博云打印机 12蓝牙打印机-标签打印机安卓
        let tp = '2';
        switch (type) {
            case '1':
                tp = '2';
                break;
            case '2':
                tp = '4';
                break;
            case '4':
                if (printer == 3) {
                    tp = '7'
                } else {
                    tp = '1';
                }
                break;
            case '3':
                if (printer == 3) {
                    tp = '9';
                } else {
                    tp = '3';
                }
                break;
            case '5':
                if (printer == 3) {
                    tp = '8'
                } else {
                    tp = '5';
                }
                break;
            case '7':
                tp = '11';
                break;
            default:
                tp = type;
                break;
        }
        return tp;
    }
}

//乘法
export function accMul(arg1, arg2) {
    var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
    try {
        m += s1.split(".")[1].length
    } catch (e) {
    }
    try {
        m += s2.split(".")[1].length
    } catch (e) {
    }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
}

//加法
export function accAdd(arg1, arg2) {
    var r1, r2, m;
    try {
        r1 = arg1.toString().split(".")[1].length
    } catch (e) {
        r1 = 0
    }
    try {
        r2 = arg2.toString().split(".")[1].length
    } catch (e) {
        r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    return (arg1 * m + arg2 * m) / m
}

//减法
export function subTr(arg1, arg2) {
    var r1, r2, m, n;
    try {
        r1 = arg1.toString().split(".")[1].length
    } catch (e) {
        r1 = 0
    }
    try {
        r2 = arg2.toString().split(".")[1].length
    } catch (e) {
        r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2));
    n = (r1 >= r2) ? r1 : r2;
    return ((arg1 * m - arg2 * m) / m).toFixed(n);
}

//主要模板
var context4 = [{
    "shopName": "店掌宝商店", //门店名称  店掌宝商店
    "pageTitle": "结账单",    //打印标题
    "headerFieldList": ["桌号", "日期", "订单单号", "流水号", "操作员"],
    "headerTitleList": ["A001", "2022-05-10 17:21:20", "100123212344214", "001", "管理员"],

    "mainFieldList": [],// ["名称","数量","小计"],
    "mainList": [["小炒黄牛肉", "2", "12"], ["辣椒炒肉", "3", "12"]],

    "secMainTitle": "加菜",    //打印标题2-可选  加菜
    "secMainFieldList": ["名称", "数量", "小计"],
    "secMainList": [["酸辣土豆丝", "2", "12"], ["西湖牛肉羹", "3", "12"]],


    "thrMainTitle": "价格明细", //打印标题2-可选  价格明细
    "thrMainFieldList": ["原价", "会员", "折扣", "抹零", "退款", "实付"],
    "thrMainList": ["60.02", "0.00", "0", "0.00", "0.00", "60.02"],

    "footerFieldList": ["电话", "地址"],
    "footerTitleList": ["13535354054", "湖北省武汉市文化大道555号融创智谷A6-603"],

    "isCutPage": 0, // 是否切纸 0不切 1切纸
}];
// 日报
var context3 = [{
    "shopName": "阿莫的烧烤铺子", //门店名称  店掌宝商店
    "pageTitle": "日报",    //打印标题
    "headerFieldList": ["负责人", "日期"],
    "headerTitleList": ["店长", "2022-05-10"],

    "saleActualCollectionList": [["销售实收", "60笔", "4600.00"], ["应收金额", "60笔", "4800.00"], ["退款金额", "2笔", "200.00"]],

    "saveActualCollectionList": [["储值实收", "1笔", "1000.00"], ["赠送金额", "1笔", "100.00"]],

    "businessIncomeList": [["营业收入", "5000.00"], ["销售实收", "4600.00"], ["储值实收", "1000.00"], ["会员余额重复扣减", "-600.00"]],

    "thrMainTitle": "收退款构成", //打印标题2-可选
    "thrMainList": [["现金", "+1000.00", "-0.00"], ["会员余额", "+600.00", "-0.00"], ["微信", "+1600.00", "-0.00"], ["支付宝", "+1600.00", "-100.00"], ["云闪付", "+1000.00", "-100.00"]],
    "isCutPage": "0"
}];
// 新-日报
var context1 = [{
    "shopName": "店掌宝商店",
    "pageTitle": "日报",
    "headerFieldList": [],
    "headerTitleList": [],
    "customList": [
        ["操作员: 张首印", "开始时间: 2022-06-23 9:00:00", "结束时间: 2022-06-23 22:00:00"],
        ["营业实收:5000.00", "订单实收: 4600.00", "储值实收: 1000.00", "不计入实收：-600"],
        ["订单实收:4600.00", "应收金额 4800.00", "退款金额：-200.00", "订单数量：60笔", "退款数量：2笔"],
        ["处置实收:1000.00", "储值笔数 2笔", "赠送金额: 100.00"],
        ["收退款构成", "现金: 收 1000.00，退 0.00", "支付宝：收 1600，退100.00", "会员余额: 收600.00，退0.00"]
    ],
    "bottomContent": "店掌宝餐厅祝您用餐愉快！",
    "isCutPage": "0"
}];
// 换台通知单
var context1 = [{
    "shopName": "店掌宝商店",
    "pageTitle": "换台通知单",
    "printType": "1",
    "headerFieldList": ["原桌位: "],
    "headerTitleList": ["A1"],
    "headerFieldList2": ["更换到: "],
    "headerTitleList2": ["A1"],
    "isCutPage": "0"
}];
// 标签制作单
var tagContent = [{
    "orderName": "流水单号:Z001(堂食)",
    "foodName": "水果奶茶",
    "foodSpecs": "【中杯，温热，微糖】",
    "buyPhone": "13535354054",
    "orderPrice": "价格：20：00",
    "orderRemark": "备注：不要吸管",
    "orderTime": "时间：2022-12-30 16：19：10",
    "shopName": "融创智谷奶茶店"
}];

// 安卓打印对接数据处理
export function outPrintdataProcess(data, pro_type, size) {
    // console.log('安卓打印对接数据处理 传入的数据', JSON.stringify(data));
    let arr = [];
    let printObj = {}
    // 点菜单
    if (data.type == 2) {
        printObj['shopName'] = data.shopName;
        printObj['pageTitle'] = data.isReprint == 1 ? '点菜单补打' : '点菜单';
        printObj['printType'] = '0';

        printObj['headerFieldList'] = [];
        printObj['headerTitleList'] = [];
        if (data.meal_type == 1) {
            printObj['headerFieldList'] = [`${data.order_type}:`, "人数：", "下单人员：", "下单时间：", "订单单号："];
            printObj['headerTitleList'] = [data.desk_num || data.num, data.people, (data.admin_name || ''), data.date + ' ' + data.time, data.orderNum];
        } else {
            printObj['headerFieldList'] = [`${data.order_type}:`, "下单人员：", "下单时间：", "订单单号："];
            if (data.order_type_index == 1 || data.order_type_index == 2) {
                printObj['headerTitleList'] = [data.serial_number, (data.admin_name || ''), data.date + ' ' + data.time, data.orderNum];
            } else {
                printObj['headerTitleList'] = [data.pick_order_num, (data.admin_name || ''), data.date + ' ' + data.time, data.orderNum];
            }
        }

        printObj['customList'] = [];
        if (data.remark || data.order_remark) {
            printObj["customList"] = [[], []];
            printObj["customList"][1] = [`备注：${data.remark || data.order_remark}`];
        }

        if (data.printDishList.length < 1) {
            printObj['mainFieldList'] = [];
            printObj['mainList'] = [];
        }
        if (data.printDishList.length > 0) {
            printObj['mainFieldList'] = ["名称", "单价", "数量", "小计"];
            let mainList = [];
            data.printDishList.forEach((element, i) => {
                let food = [];
                if (element[8] == 3 && element[9] && element[9] != '') {
                    food.push([`${i + 1}.(套)${element[1]}`, element[4], element[2].toString(), element[3]]);
                    let setmeal = JSON.parse(element[9]);
                    setmeal.forEach(setmeal_food => {
                        food.push([`  ${setmeal_food.name}${setmeal_food.attr != '' ? '(' + setmeal_food.attr + ')' : ''}×${setmeal_food.num}`])
                    });
                    mainList.push(...food);
                    printObj['is_package'] = '1';
                } else {
                    if (element[5] && element[5] != '' && element[7] != 1) {
                        food = [`${i + 1}.${element[1]}`, element[4], element[2].toString(), element[3], `【${element[5]}】`];
                    } else {
                        food = [`${i + 1}.${element[1]}`, element[4], element[2].toString(), element[3]];
                    }
                    mainList.push(food);
                }
            });
            printObj['mainList'] = mainList;
        }

        // -------这一部分应该没用了
        if (data.addprintDishList.length < 1) {
            printObj['secMainTitle'] = '';
            printObj['secMainFieldList'] = [];
            printObj['secMainList'] = [];
        }
        if (data.addprintDishList.length > 0) {
            printObj['secMainTitle'] = '加菜';
            printObj['secMainFieldList'] = ["名称", "单价", "数量", "小计"];
            let secMainList = [];
            data.addprintDishList.forEach((element, i) => {
                let food = [];
                if (element[8] == 3 && element[9] && element[9] != '') {
                    food.push([`${i + 1}.(套)${element[1]}`, element[4], element[2].toString(), element[3]]);
                    let setmeal = JSON.parse(element[9]);
                    setmeal.forEach(setmeal_food => {
                        food.push([`  ${setmeal_food.name}${setmeal_food.attr != '' ? '(' + setmeal_food.attr + ')' : ''}×${setmeal_food.num}`])
                    });
                    secMainList.push(...food);
                } else {
                    if (element[5] && element[5] != '' && element[7] != 1) {
                        food = [`${i + 1}.${element[1]}`, element[4], element[2].toString(), element[3], `【${element[5]}】`];
                    } else {
                        food = [`${i + 1}.${element[1]}`, element[4], element[2].toString(), element[3]];
                    }
                    secMainList.push(food);
                }
            });
            printObj['secMainList'] = secMainList;
        }
        // ------这一部分应该没用了

        let hejiPrice = '0.00';
        if (data.one_dis) {
            if (data.one_dis === 'one_dis') {
                hejiPrice = data.allOriginalPrice.toString();
            } else {
                hejiPrice = data.one_dis.toString();
            }
        }
        printObj['thrMainTitle'] = '订单合计：' + hejiPrice;
        printObj['thrMainFieldList'] = [];
        printObj['thrMainList'] = [];

        printObj['customContent'] = [];
        printObj['customFont'] = '';

        printObj["footerFieldList"] = ["门店地址：", "联系电话："];
        printObj["footerTitleList"] = [data.address, data.phone];

        printObj['bottomContent'] = '店掌宝祝您用餐愉快！';

        printObj['isCutPage'] = store.state.isCutPage; // 是否切纸 0不切 1切纸

        arr.push(printObj);
    }

    // 加菜单
    if (data.type == 22) {
        printObj['shopName'] = data.shopName;
        printObj['pageTitle'] = '加菜单';
        printObj['printType'] = '0';

        printObj['headerFieldList'] = [`${data.order_type}:`, "加菜时间：", "订单单号："];
        printObj['headerTitleList'] = [];
        if (data.meal_type == 1) {
            printObj['headerTitleList'] = [data.desk_num || data.num, data.create_time || '', data.orderNum];
        } else {
            let pack_or_dineIn_text = ``;
            if (data.pack_or_dineIn == 1) { // 打包
                pack_or_dineIn_text = '(打包)'
            } else if (data.pack_or_dineIn == 2) { // 堂食
                pack_or_dineIn_text = '(堂食)'
            }
            if (data.order_type_index == 1 || data.order_type_index == 2) {
                printObj['headerTitleList'] = [`${data.serial_number}${pack_or_dineIn_text}`, data.create_time || '', data.orderNum];
            } else {
                printObj['headerTitleList'] = [`${data.pick_order_num}${pack_or_dineIn_text}`, data.create_time || '', data.orderNum];
            }
        }

        printObj['customList'] = [];
        if (data.remark || data.order_remark) {
            printObj["customList"] = [[], []];
            printObj["customList"][1] = [`备注：${data.remark || data.order_remark}`];
        }

        if (data.addprintDishList.length < 1) {
            printObj['mainFieldList'] = [];
            printObj['mainList'] = [];
        }
        if (data.addprintDishList.length > 0) {
            printObj['mainFieldList'] = ["名称", "单价", "数量", "小计"];
            let mainList = [];
            data.addprintDishList.forEach((element, i) => {
                let food = [];
                if (element[8] == 3 && element[9] && element[9] != '') {
                    food.push([`${i + 1}.(套)${element[1]}`, element[4], element[2].toString(), element[3]]);
                    let setmeal = JSON.parse(element[9]);
                    setmeal.forEach(setmeal_food => {
                        food.push([`  ${setmeal_food.name}${setmeal_food.attr != '' ? '(' + setmeal_food.attr + ')' : ''}×${setmeal_food.num}`])
                    });
                    mainList.push(...food);
                    printObj['is_package'] = '1';
                } else {
                    if (element[5] && element[5] != '' && element[7] != 1) {
                        food = [`${i + 1}.${element[1]}`, element[4], element[2].toString(), element[3], `【${element[5]}】`];
                    } else {
                        food = [`${i + 1}.${element[1]}`, element[4], element[2].toString(), element[3]];
                    }
                    mainList.push(food);
                }
            });
            printObj['mainList'] = mainList;
        }

        printObj['secMainTitle'] = '';
        printObj['secMainFieldList'] = [];
        printObj['secMainList'] = [];

        let hejiPrice = '0.00';
        if (data.one_dis) {
            if (data.one_dis === 'one_dis') {
                hejiPrice = data.allOriginalPrice.toString();
            } else {
                hejiPrice = data.one_dis.toString();
            }
        }
        printObj['thrMainTitle'] = '订单合计：' + hejiPrice;
        printObj['thrMainFieldList'] = [];
        printObj['thrMainList'] = [];

        printObj['customContent'] = [];
        printObj['customFont'] = '';

        printObj["footerFieldList"] = [];
        printObj["footerTitleList"] = [];

        printObj['bottomContent'] = '';

        printObj['isCutPage'] = store.state.isCutPage; // 是否切纸 0不切 1切纸

        arr.push(printObj);
    }

    // 结账单
    if (data.type == 4) {
        printObj['shopName'] = data.shopName;

        let xiaop = '';
        if (data.meal_type == 1 || (data.meal_type == 2 && data.order_type_index == 2)) {
            xiaop = data.isReprint == 1 ? '结账单补打' : '结账单';
        } else {
            if (data.order_type_index == 3) {
                xiaop = '自取单';
            } else if (data.order_type_index == 4) {
                xiaop = '外卖单';
            }
        }
        printObj['pageTitle'] = xiaop;

        printObj['printType'] = '0';

        printObj['headerFieldList'] = [];
        printObj['headerTitleList'] = [];
        if (data.meal_type == 1) {
            printObj['headerFieldList'] = [`${data.order_type}:`, "人数：", "收银人员：", "收银时间：", "订单单号："];
            printObj['headerTitleList'] = [data.desk_num || data.num, data.people, (data.admin_name || ''), data.cashier_time || '', data.orderNum];
        } else {
            let pack_or_dineIn_text = ``;
            if (data.pack_or_dineIn == 1) { // 打包
                pack_or_dineIn_text = '(打包)'
            } else if (data.pack_or_dineIn == 2) { // 堂食
                pack_or_dineIn_text = '(堂食)'
            }
            if (data.order_type_index == 1 || data.order_type_index == 2) {
                printObj['headerFieldList'] = [`${data.order_type}:`, "收银人员：", "收银时间：", "订单单号："];
                printObj['headerTitleList'] = [`${data.serial_number}${pack_or_dineIn_text}`, (data.admin_name || ''), data.cashier_time || '', data.orderNum];
            } else {
                printObj['headerFieldList'] = [`${data.order_type}:`, "下单时间：", "订单单号："];
                printObj['headerTitleList'] = [`${data.pick_order_num}${pack_or_dineIn_text}`, data.down_time || '', data.orderNum];
            }
        }

        printObj["customList"] = [];
        if (data.order_type_index == 4) {
            printObj["customList"] = [[], []];
            if (data.order_type_index == 4) { // 外卖订单
                if (data.c_name && data.c_name != '') {
                    printObj["customList"][0].push('姓名：' + data.c_name);
                }
                if (data.c_phone && data.c_phone != '') {
                    printObj["customList"][0].push('电话：' + data.c_phone);
                }
                if (data.send_address && data.send_address != '') {
                    printObj["customList"][0].push('地址：' + data.send_address);
                }
            }
            if (data.remark && data.remark != '') {
                printObj["customList"][1] = [`备注：${data.remark}`];
            }
        } else {
            if (data.remark && data.remark != '') {
                printObj["customList"] = [[], []];
                printObj["customList"][1] = [`备注：${data.remark}`];
            }
        }

        if (data.printDishList.length < 1) {
            printObj['mainFieldList'] = [];
            printObj['mainList'] = [];
        }
        if (data.printDishList.length > 0) {
            printObj['mainFieldList'] = ["名称", "单价", "数量", "小计"];
            let mainList = [];
            data.printDishList.forEach((element, i) => {
                let food = [];
                if (element[8] == 3 && element[9] && element[9] != '') {
                    food.push([`${i + 1}.(套)${element[1]}`, element[4], element[2].toString(), element[3]]);
                    let setmeal = JSON.parse(element[9]);
                    setmeal.forEach(setmeal_food => {
                        food.push([`  ${setmeal_food.name}${setmeal_food.attr != '' ? '(' + setmeal_food.attr + ')' : ''}×${setmeal_food.num}`])
                    });
                    mainList.push(...food);
                    printObj['is_package'] = '1';
                } else {
                    if (element[5] && element[5] != '' && element[7] != 1) {
                        food = [`${i + 1}.${element[1]}`, element[4], element[2].toString(), element[3], `【${element[5]}】`];
                    } else {
                        food = [`${i + 1}.${element[1]}`, element[4], element[2].toString(), element[3]];
                    }
                    mainList.push(food);
                }
            });
            printObj['mainList'] = mainList;
        }

        printObj['secMainTitle'] = '';
        printObj['secMainFieldList'] = ['订单合计：'];
        printObj['secMainList'] = [data.allOriginalPrice];
        if (data.order_type_index == 4 && data.deliver_fee && data.deliver_fee > 0) {
            printObj['secMainFieldList'].push(`配送费：`);
            printObj['secMainList'].push(`${data.deliver_fee.toString()}`);
        }
        if (data.discount_price && data.discount_price > 0) {
            printObj['secMainFieldList'].push(`[会员优惠:${data.member_level_rate >= 100 ? '' : parseFloat(data.member_level_rate / 10).toFixed(2) + '折'}]：`);
            printObj['secMainList'].push(`-${data.discount_price.toString()}`);
        }
        if (data.dis_price && data.dis_price > 0) {
            printObj['secMainFieldList'].push(`[整单打折:${data.discount_rate >= 100 ? '' : parseFloat(data.discount_rate / 10).toFixed(2) + '折'}]：`);
            printObj['secMainList'].push(`-${data.dis_price.toString()}`);
        }
        if (data.wipe_price && data.wipe_price > 0) {
            printObj['secMainFieldList'].push(`[抹零]：`);
            printObj['secMainList'].push(`-${data.wipe_price.toString()}`);
        }

        printObj['thrMainTitle'] = '';
        printObj['thrMainFieldList'] = ['应收：'];
        printObj['thrMainList'] = [data.payPrice];
        if (data.return_money && data.return_money > 0) {
            printObj['thrMainFieldList'].push('退款：');
            printObj['thrMainList'].push(`-${data.return_money.toString()}`);
        }
        printObj['thrMainFieldList'].push(`实收${data.pay_mode_text ? '(' + data.pay_mode_text + ')' : ''}:`);
        printObj['thrMainList'].push(data.allFactPrice);

        printObj['customContent'] = [];
        printObj['customFont'] = '';

        printObj["footerFieldList"] = ["门店地址：", "联系电话："];
        printObj["footerTitleList"] = [data.address, data.phone];

        // 1微信 2支付宝 3会员钱包 4微信线上 5支付宝线上 6现金 7会员卡 8收呗微信线上
        if ((data.order_type_index == 1 || data.order_type_index == 2) && data.pay_method == 3) {
            const phone = data.member_phone && data.member_phone != '' ? data.member_phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2') : '';
            const field_ = ["会员姓名：", "会员电话：", "余额："];
            const title_ = [data.member_name || '', phone, data.member_balance || ''];
            printObj["footerFieldList"].unshift(...field_);
            printObj["footerTitleList"].unshift(...title_);
        }

        printObj["bottomContent"] = '店掌宝祝您用餐愉快！';

        printObj['isCutPage'] = store.state.isCutPage; // 是否切纸 0不切 1切纸

        arr.push(printObj);
    }

    // 客单-没用
    if (data.type == 23) {
        printObj['shopName'] = data.shopName;

        let xiaop = '';
        if (data.meal_type == 1 || (data.meal_type == 2 && data.order_type_index == 2)) {
            xiaop = data.isReprint == 1 ? '客单补打' : '客单';
        } else {
            if (data.order_type_index == 3) {
                xiaop = '自取单';
            } else if (data.order_type_index == 4) {
                xiaop = '外卖单';
            }
        }
        printObj['pageTitle'] = xiaop;

        printObj['printType'] = '0';

        printObj['headerFieldList'] = [];
        printObj['headerTitleList'] = [];
        if (data.meal_type == 1) {
            printObj['headerFieldList'] = [`${data.order_type}:`, "人数：", "收银人员：", "收银时间：", "订单单号："];
            printObj['headerTitleList'] = [data.desk_num || data.num, data.people, (data.admin_name || ''), data.cashier_time || '', data.orderNum];
        } else {
            let pack_or_dineIn_text = ``;
            if (data.pack_or_dineIn == 1) { // 打包
                pack_or_dineIn_text = '(打包)'
            } else if (data.pack_or_dineIn == 2) { // 堂食
                pack_or_dineIn_text = '(堂食)'
            }
            if (data.order_type_index == 1 || data.order_type_index == 2) {
                printObj['headerFieldList'] = [`${data.order_type}:`, "收银人员：", "收银时间：", "订单单号："];
                printObj['headerTitleList'] = [`${data.serial_number}${pack_or_dineIn_text}`, (data.admin_name || ''), data.cashier_time || '', data.orderNum];
            } else {
                printObj['headerFieldList'] = [`${data.order_type}:`, "下单时间：", "订单单号："];
                printObj['headerTitleList'] = [`${data.pick_order_num}${pack_or_dineIn_text}`, data.down_time || '', data.orderNum];
            }
        }

        printObj["customList"] = [];
        if (data.order_type_index == 4) {
            printObj["customList"] = [[], []];
            if (data.order_type_index == 4) { // 外卖订单
                if (data.c_name && data.c_name != '') {
                    printObj["customList"][0].push('姓名：' + data.c_name);
                }
                if (data.c_phone && data.c_phone != '') {
                    printObj["customList"][0].push('电话：' + data.c_phone);
                }
                if (data.send_address && data.send_address != '') {
                    printObj["customList"][0].push('地址：' + data.send_address);
                }
            }
            if (data.remark && data.remark != '') {
                printObj["customList"][1] = [`备注：${data.remark}`];
            }
        } else {
            if (data.remark && data.remark != '') {
                printObj["customList"] = [[], []];
                printObj["customList"][1] = [`备注：${data.remark}`];
            }
        }

        if (data.printDishList.length < 1) {
            printObj['mainFieldList'] = [];
            printObj['mainList'] = [];
        }
        if (data.printDishList.length > 0) {
            printObj['mainFieldList'] = ["名称", "单价", "数量", "小计"];
            let mainList = [];
            data.printDishList.forEach((element, i) => {
                let food = [];
                if (element[5] && element[5] != '' && element[7] != 1) {
                    food = [`${i + 1}.${element[1]}`, element[4], element[2].toString(), element[3], `【${element[5]}】`];
                } else {
                    food = [`${i + 1}.${element[1]}`, element[4], element[2].toString(), element[3]];
                }
                mainList.push(food);
            });
            printObj['mainList'] = mainList;
        }

        printObj['secMainTitle'] = '';
        printObj['secMainFieldList'] = ['订单合计：'];
        printObj['secMainList'] = [data.allOriginalPrice];
        if (data.order_type_index == 4 && data.deliver_fee && data.deliver_fee > 0) {
            printObj['secMainFieldList'].push(`配送费：`);
            printObj['secMainList'].push(`${data.deliver_fee.toString()}`);
        }
        if (data.discount_price && data.discount_price > 0) {
            printObj['secMainFieldList'].push(`[会员优惠:${data.member_level_rate >= 100 ? '' : parseFloat(data.member_level_rate / 10).toFixed(2) + '折'}]：`);
            printObj['secMainList'].push(`-${data.discount_price.toString()}`);
        }
        if (data.dis_price && data.dis_price > 0) {
            printObj['secMainFieldList'].push(`[整单打折:${data.discount_rate >= 100 ? '' : parseFloat(data.discount_rate / 10).toFixed(2) + '折'}]：`);
            printObj['secMainList'].push(`-${data.dis_price.toString()}`);
        }
        if (data.wipe_price && data.wipe_price > 0) {
            printObj['secMainFieldList'].push(`[抹零]：`);
            printObj['secMainList'].push(`-${data.wipe_price.toString()}`);
        }

        printObj['thrMainTitle'] = '';
        printObj['thrMainFieldList'] = ['应收：'];
        printObj['thrMainList'] = [data.payPrice];
        if (data.return_money && data.return_money > 0) {
            printObj['thrMainFieldList'].push('退款：');
            printObj['thrMainList'].push(`-${data.return_money.toString()}`);
        }
        printObj['thrMainFieldList'].push(`实收${data.pay_mode_text ? '(' + data.pay_mode_text + ')' : ''}:`);
        printObj['thrMainList'].push(data.allFactPrice);

        printObj['customContent'] = [];
        printObj['customFont'] = '';

        printObj["footerFieldList"] = ["门店地址：", "联系电话："];
        printObj["footerTitleList"] = [data.address, data.phone];

        printObj["bottomContent"] = '店掌宝祝您用餐愉快！';

        printObj['isCutPage'] = store.state.isCutPage; // 是否切纸 0不切 1切纸

        arr.push(printObj);
    }

    // 前台做菜单
    if (data.type == 19) {
        printObj['shopName'] = data.shopName;
        printObj['pageTitle'] = '做菜单';
        printObj['printType'] = '0';
        printObj['headerFieldList'] = [`${data.order_type}:`, "下单时间：", "订单单号："];
        printObj['headerTitleList'] = [];
        if (data.meal_type == 1) {
            printObj['headerTitleList'] = [data.desk_num || data.num, data.create_time || '', data.orderNum];
        } else {
            let pack_or_dineIn_text = ``;
            if (data.pack_or_dineIn == 1) { // 打包
                pack_or_dineIn_text = '(打包)'
            } else if (data.pack_or_dineIn == 2) { // 堂食
                pack_or_dineIn_text = '(堂食)'
            }
            if (data.order_type_index == 1 || data.order_type_index == 2) {
                printObj['headerTitleList'] = [`${data.serial_number}${pack_or_dineIn_text}`, data.create_time, data.orderNum];
            } else {
                printObj['headerTitleList'] = [`${data.pick_order_num}${pack_or_dineIn_text}`, data.create_time, data.orderNum];
            }
        }

        printObj['customList'] = [];
        if (data.remark || data.order_remark) {
            printObj["customList"] = [[], []];
            printObj["customList"][1] = [`备注：${data.remark || data.order_remark}`];
        }

        printObj['mainFieldList'] = [];
        printObj['mainList'] = [];

        printObj['secMainTitle'] = '';
        printObj['secMainFieldList'] = [];
        printObj['secMainList'] = [];

        printObj["thrMainTitle"] = ""; //打印标题2-可选  价格明细
        printObj["thrMainFieldList"] = [];
        printObj["thrMainList"] = [];

        printObj['customContent'] = [];
        if (data.foodsList.length > 0) {
            let mainList = [];
            data.foodsList.forEach((element, i) => {
                let food = [];
                if (element.type == 3) {
                    food.push([`${i + 1}.(套)${element.food_name}`, `${element.food_num.toString()}${element.unit_name || '份'}`]);
                    if (element.spec_json) {
                        const info = element.spec_json.setmeal_list || [];
                        for (let m = 0; m < info.length; m++) {
                            const mealfood = info[m];
                            food.push([`${mealfood.name}${mealfood.attr != '' ? '(' + mealfood.attr + ')' : ''}`, `×${mealfood.num}`]);
                        }
                    }
                    mainList.push(...food);
                } else {
                    if (element.spec_attr_name && element.spec_attr_name != '' && element.food_spec_fake != 1) {
                        food = [`${i + 1}.${element.food_name}`, `${element.food_num.toString()}${element.type == 1 ? (element.unit_name || '份') : ''}`, `【${element.spec_attr_name}】`];
                    } else {
                        food = [`${i + 1}.${element.food_name}`, `${element.food_num.toString()}${element.type == 1 ? (element.unit_name || '份') : ''}`];
                    }
                    mainList.push(food);
                }
            });
            printObj['customContent'] = mainList;
        }

        printObj['customFont'] = 'medium'; // normal,medium,big

        printObj["footerFieldList"] = [];
        printObj["footerTitleList"] = [];
        // if (data.remark || data.order_remark) {
        //   printObj["footerFieldList"] = ['备注：'];
        //   printObj["footerTitleList"] = [data.remark || data.order_remark];
        // }

        printObj['bottomContent'] = '';

        printObj['isCutPage'] = store.state.isCutPage; // 是否切纸 0不切 1切纸

        arr.push(printObj);
    }

    // 日报
    if (data.type == 21) {
        printObj['shopName'] = data.shop_name;
        printObj['pageTitle'] = '日报';

        printObj['printType'] = '0';

        printObj['headerFieldList'] = [];
        printObj['headerTitleList'] = [];

        let dailydata = {};
        try {
            dailydata = JSON.parse(data.daily)
        } catch (err) {
            dailydata = {}
        }
        let customList = [];
        customList[0] = [
            `操作员：${data.shop_admin_name || '无'}`,
            `开始时间：${data.start_time || '无'}`,
            `结束时间：${data.end_time || '无'}`,
        ];
        for (const key in dailydata) {
            if (Object.hasOwnProperty.call(dailydata, key)) {
                const element = dailydata[key];
                let cusData = [];
                for (let i = 0; i < element.length; i++) {
                    const ele = element[i];
                    cusData.push(`${ele.label || ''}${ele.middleVal || ''}${ele.value || ''}`)
                }
                customList.push(cusData);
            }
        }
        printObj['customList'] = customList;

        printObj['mainFieldList'] = [];
        printObj['mainList'] = [];
        printObj['secMainTitle'] = '';
        printObj['secMainFieldList'] = [];
        printObj['secMainList'] = [];
        printObj['thrMainTitle'] = '';
        printObj['thrMainFieldList'] = [];
        printObj['thrMainList'] = [];
        printObj['customContent'] = [];
        printObj['customFont'] = '';
        printObj['footerFieldList'] = [];
        printObj['footerTitleList'] = [];

        printObj['bottomContent'] = '店掌宝祝您生意兴隆！';
        printObj['isCutPage'] = store.state.isCutPage; // 是否切纸 0不切 1切纸

        arr.push(printObj);
    }

    // 前台退菜单
    if (data.type == 27) {
        printObj['shopName'] = data.shopName;
        printObj['pageTitle'] = '退菜单';
        printObj['printType'] = '0';
        printObj['headerFieldList'] = ["桌位号:", "退菜时间：", "订单单号："];
        printObj['headerTitleList'] = [data.desk_num, data.return_time, data.orderNum];

        printObj['customList'] = [];

        let returnFoodsList = [];
        try {
            returnFoodsList = JSON.parse(data.returnFoodsList)
        } catch (err) {
            returnFoodsList = []
        }
        if (returnFoodsList.length < 1) {
            printObj['mainFieldList'] = [];
            printObj['mainList'] = [];
        }
        if (returnFoodsList.length > 0) {
            printObj['mainFieldList'] = ["名称", "单价", "数量", "小计"];
            let mainList = [];
            returnFoodsList.forEach((element, i) => {
                // console.log('前台退菜单 element', element);
                let food = [];
                if (element.type == 3) {
                    food.push([`${i + 1}.(套)${element.food_name}`, element.price, `-${element.return_num.toString()}`, `-${element.totalPrice}`]);
                    for (let m = 0; m < element.c_setmeal_list.length; m++) {
                        const mealfood = element.c_setmeal_list[m];
                        food.push([`${mealfood.name}${mealfood.attr != '' ? '(' + mealfood.attr + ')' : ''}×${mealfood.num}`]);
                    }
                    mainList.push(...food);
                    printObj['is_package'] = '1';
                } else {
                    if (element.spec_attr_name && element.spec_attr_name != '' && element.food_spec_fake != 1) {
                        food = [`${i + 1}.${element.food_name}`, element.price, `-${element.return_num.toString()}`, `-${element.totalPrice}`, `【${element.spec_attr_name}】`];
                    } else {
                        food = [`${i + 1}.${element.food_name}`, element.price, `-${element.return_num.toString()}`, `-${element.totalPrice}`];
                    }
                    mainList.push(food);
                }
            });
            printObj['mainList'] = mainList;
        }
        printObj['secMainTitle'] = '';
        printObj['secMainFieldList'] = [];
        printObj['secMainList'] = [];

        printObj["thrMainTitle"] = `订单合计：-${data.returnTotalPrice || '0'}`;
        printObj["thrMainFieldList"] = [];
        printObj["thrMainList"] = [];

        printObj['customContent'] = [];
        printObj['customFont'] = '';

        printObj["footerFieldList"] = [];
        printObj["footerTitleList"] = [];

        printObj['bottomContent'] = '';

        printObj['isCutPage'] = store.state.isCutPage; // 是否切纸 0不切 1切纸

        arr.push(printObj);
    }

    // 后厨退菜单
    if (data.type == 18) {
        printObj['shopName'] = '';
        printObj['pageTitle'] = '【退菜单】';
        printObj['printType'] = '2';
        printObj['headerFieldList'] = ["桌位号:", "退菜时间：", "订单单号："];
        printObj['headerTitleList'] = [data.desk_num, data.return_time, data.orderNum];

        printObj['customList'] = [];

        let returnFoodsList = [];
        try {
            // console.log('typeof data.returnFoodsList', typeof data.returnFoodsList);
            if (typeof data.returnFoodsList == 'string') {
                returnFoodsList = JSON.parse(data.returnFoodsList);
            } else {
                returnFoodsList = data.returnFoodsList;
            }
        } catch (err) {
            returnFoodsList = []
        }
        printObj['mainFieldList'] = [];
        printObj['mainList'] = [];

        printObj['secMainTitle'] = '';
        printObj['secMainFieldList'] = [];
        printObj['secMainList'] = [];

        printObj["thrMainTitle"] = ""; //打印标题2-可选  价格明细
        printObj["thrMainFieldList"] = [];
        printObj["thrMainList"] = [];

        printObj['customContent'] = [];
        if (returnFoodsList.length > 0) {
            let mainList = [];
            const element = returnFoodsList[0];
            if (element.spec_attr_name && element.spec_attr_name != '' && element.food_spec_fake != 1) {
                mainList = [element.food_name, `-${element.return_num.toString()}`, `【${element.spec_attr_name}】`];
            } else {
                mainList = [element.food_name, `-${element.return_num.toString()}`];
            }
            printObj['customContent'] = [mainList];
        }
        printObj['customFont'] = 'medium'; // normal,medium,big

        printObj["footerFieldList"] = ['退菜原因：'];
        printObj["footerTitleList"] = [data.reason];

        printObj['bottomContent'] = '';

        printObj['isCutPage'] = store.state.isCutPage; // 是否切纸 0不切 1切纸

        arr.push(printObj);
    }

    // 后厨做菜单
    if (data.type == 3) {
        if (data.foodsList.length < 1) {
            arr = [];
        } else {
            if (data.isMerge == '0' || data.isMerge == '1') { // 一菜一单
                let foodArr_1 = getHcFoodsTemp(data, 1);
                arr.push(...foodArr_1);
            } else if (data.isMerge == '3') { // 多菜一单+一菜一单
                let foodArr_2 = getHcFoodsTemp(data, 2);
                // console.log('foodArr_2', foodArr_2);
                let foodArr_1 = getHcFoodsTemp(data, 1);
                // console.log('foodArr_1', foodArr_1);
                arr.push(...foodArr_2, ...foodArr_1);
            } else { // 多菜一单
                let foodArr_2 = getHcFoodsTemp(data, 2);
                arr.push(...foodArr_2);
            }
        }
    }

    // 前台换台通知单
    if (data.type == 24) {
        printObj['shopName'] = data.shopName;
        printObj['pageTitle'] = '换台通知单';
        printObj['printType'] = '1';

        printObj['headerFieldList'] = ['原桌位：'];
        printObj['headerTitleList'] = [`${data.cur_desk_num}`];

        printObj['headerFieldList2'] = ['更换到：'];
        printObj['headerTitleList2'] = [`${data.change_desk_num}`];

        if (pro_type == 'dqprint') {
            printObj['customList'] = [[], [`更换到：${data.change_desk_num}`]];
            printObj['mainFieldList'] = [];
            printObj['mainList'] = [];
            printObj['secMainTitle'] = '';
            printObj['secMainFieldList'] = [];
            printObj['secMainList'] = [];
            printObj['thrMainTitle'] = '';
            printObj['thrMainFieldList'] = [];
            printObj['thrMainList'] = [];
            printObj['customContent'] = [];
            printObj['customFont'] = '';
            printObj['footerFieldList'] = [];
            printObj['footerTitleList'] = [];
        }

        printObj['isCutPage'] = store.state.isCutPage; // 是否切纸 0不切 1切纸

        arr.push(printObj);
    }

    // 标签制作单
    if (data.type == 25) {
        if (data.labelFoods.length < 1) {
            arr = [];
        } else {
            for (let i = 0; i < data.labelFoods.length; i++) {
                const element = data.labelFoods[i];
                if (element.type == 1 || element.food_type == 1) {
                    for (let j = 0; j < element.food_num; j++) {
                        let lablePrintObj = {}
                        lablePrintObj['orderName'] = '';
                        if (data.meal_type == 1) {
                            lablePrintObj['orderName'] = `${data.order_type}:${data.desk_num || data.num}`;
                        } else {
                            let pack_or_dineIn_text = ``;
                            if (data.pack_or_dineIn == 1) { // 打包
                                pack_or_dineIn_text = '(打包)'
                            } else if (data.pack_or_dineIn == 2) { // 堂食
                                pack_or_dineIn_text = '(堂食)'
                            }
                            if (data.order_type_index == 1 || data.order_type_index == 2) {
                                lablePrintObj['orderName'] = `${data.order_type}:${data.serial_number}${pack_or_dineIn_text}`;
                            } else {
                                lablePrintObj['orderName'] = `${data.order_type}:${data.pick_order_num}${pack_or_dineIn_text}`;
                            }
                        }

                        lablePrintObj['foodName'] = element.food_name;

                        lablePrintObj['foodSpecs'] = ``;
                        if (element.spec_attr_name && element.spec_attr_name != '' && element.food_spec_fake != 1) {
                            lablePrintObj['foodSpecs'] = `【${element.spec_attr_name}】`;
                        }

                        lablePrintObj['buyPhone'] = '';
                        if (data.order_type_index == 4 && data.c_phone && data.c_phone != '') {
                            lablePrintObj['buyPhone'] = `电话:${data.c_phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')}`;
                        }
                        if (data.order_type_index != 4 && data.member_phone && data.member_phone != '') {
                            lablePrintObj['buyPhone'] = `电话:${data.member_phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')}`;
                        }

                        lablePrintObj['orderPrice'] = `${element.price}元`;

                        lablePrintObj['orderRemark'] = '';
                        if (data.remark || data.order_remark) {
                            lablePrintObj['orderRemark'] = data.remark || data.order_remark;
                        }

                        lablePrintObj['orderTime'] = `时间:${data.create_time || ''}`;

                        lablePrintObj['shopName'] = data.shopName;

                        arr.push(lablePrintObj);
                    }
                } else {
                    let lablePrintObj = {}
                    lablePrintObj['orderName'] = '';
                    if (data.meal_type == 1) {
                        lablePrintObj['orderName'] = `${data.order_type}:${data.desk_num || data.num}`;
                    } else {
                        let pack_or_dineIn_text = ``;
                        if (data.pack_or_dineIn == 1) { // 打包
                            pack_or_dineIn_text = '(打包)'
                        } else if (data.pack_or_dineIn == 2) { // 堂食
                            pack_or_dineIn_text = '(堂食)'
                        }
                        if (data.order_type_index == 1 || data.order_type_index == 2) {
                            lablePrintObj['orderName'] = `${data.order_type}:${data.serial_number}${pack_or_dineIn_text}`;
                        } else {
                            lablePrintObj['orderName'] = `${data.order_type}:${data.pick_order_num}${pack_or_dineIn_text}`;
                        }
                    }

                    lablePrintObj['foodName'] = element.food_name;

                    lablePrintObj['foodSpecs'] = ``;
                    if (element.spec_attr_name && element.spec_attr_name != '' && element.food_spec_fake != 1) {
                        lablePrintObj['foodSpecs'] = `【${element.spec_attr_name}】`;
                    }

                    lablePrintObj['buyPhone'] = '';
                    if (data.order_type_index == 4 && data.c_phone && data.c_phone != '') {
                        lablePrintObj['buyPhone'] = `电话:${data.c_phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')}`;
                    }
                    if (data.order_type_index != 4 && data.member_phone && data.member_phone != '') {
                        lablePrintObj['buyPhone'] = `电话:${data.member_phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')}`;
                    }

                    lablePrintObj['orderPrice'] = `${element.price}元`;

                    lablePrintObj['orderRemark'] = '';
                    if (data.remark || data.order_remark) {
                        lablePrintObj['orderRemark'] = data.remark || data.order_remark;
                    }

                    lablePrintObj['orderTime'] = `时间:${data.data.create_time || ''}`;

                    lablePrintObj['shopName'] = data.shopName;

                    arr.push(lablePrintObj);
                }
            }
        }
    }

    // 充值单小票
    if (data.type == 26) {
        printObj['shopName'] = data.shopName;
        printObj['pageTitle'] = '充值单';
        printObj['printType'] = '0';

        printObj['headerFieldList'] = ['', "收银人员：", "收银时间：", "充值单号：", "会员姓名：", "会员电话："];
        printObj['headerTitleList'] = ['', data.shop_admin_name, data.recharge_time, data.recharge_no, data.member_name, data.member_phone];

        printObj['customList'] = [];

        printObj['mainFieldList'] = [];
        printObj['mainList'] = [];

        printObj['secMainTitle'] = '';
        printObj['secMainFieldList'] = ['充值金额：', `赠送金额：`, `充值前余额：`, `充值后余额：`];
        printObj['secMainList'] = [data.amount, data.give_amount, data.recharge_before, data.recharge_after];

        printObj['thrMainTitle'] = '';
        printObj['thrMainFieldList'] = [`实收${data.pay_type_text ? '(' + data.pay_type_text + ')' : ''}:`];
        printObj['thrMainList'] = [data.amount];

        printObj['customContent'] = [];
        printObj['customFont'] = '';

        printObj["footerFieldList"] = ["门店地址：", "联系电话："];
        printObj["footerTitleList"] = [data.shop_address, data.shop_phone];

        printObj["bottomContent"] = '店掌宝祝您用餐愉快！';
        printObj['isCutPage'] = store.state.isCutPage; // 是否切纸 0不切 1切纸
        arr.push(printObj);
    }

    // 寄存单
    if (data.type == 28) {
        printObj['shopName'] = data.data.shopName || '';
        printObj['pageTitle'] = '寄存单';
        printObj['printType'] = 0;
        printObj['headerFieldList'] = ['寄存单号：', '操作人员：', '寄存时间：'];
        printObj['headerTitleList'] = [data.data.deposit_num, data.data.shop_admin_name, data.data.create_time];
        printObj['customList'] = [];
        printObj['mainFieldList'] = ['寄存物品', '', '', '数量'];
        printObj['mainList'] = [];
        let mainList = [];
        data.data.good_list.forEach((element, i) => {
            let food = [];
            food = [
                `${i + 1}.${element.food_name}${element.spec && element.spec != '' ? '(' + element.spec + ')' : ''}`,
                '',
                '',
                `${element.food_num}`
            ];
            if (element.remark && element.remark != '') {
                food.push(`[备注：${element.remark}]`);
            }
            mainList.push(food);
        });
        printObj['mainList'] = mainList;
        printObj['secMainTitle'] = '';
        printObj['secMainFieldList'] = [];
        printObj['secMainList'] = [];
        printObj['thrMainTitle'] = '';
        printObj['thrMainFieldList'] = [];
        printObj['thrMainList'] = [];
        printObj['customContent'] = [];
        printObj['customFont'] = 'medium';
        printObj['footerFieldList'] = ['寄存人：', '手机号：'];
        printObj['footerTitleList'] = [data.data.username, data.data.userphone];
        if (data.data.validity_time && data.data.validity_time != '') {
            printObj['footerFieldList'].push('有效期：');
            printObj['footerTitleList'].push(data.data.validity_time);
        }
        printObj['bottomContent'] = '';
        printObj['isCutPage'] = '1';
        printObj['make'] = '';
        printObj['is_deposit'] = '1';

        arr.push(printObj);
    }

    // 取回单
    if (data.type == 29) {
        printObj['shopName'] = data.data.shopName || '';
        printObj['pageTitle'] = '取回单';
        printObj['printType'] = 0;
        printObj['headerFieldList'] = ['寄存单号：', '操作人员：', '取回时间：'];
        printObj['headerTitleList'] = [data.data.deposit_num, data.data.shop_admin_name, data.data.create_time];
        printObj['customList'] = [];
        printObj['mainFieldList'] = ['取回物品', '', '', '数量'];
        printObj['mainList'] = [];
        let mainList = [];
        data.data.good_list.forEach((element, i) => {
            let food = [];
            food = [
                `${i + 1}.${element.food_name}${element.spec && element.spec != '' ? '(' + element.spec + ')' : ''}`,
                '',
                '',
                `${element.take_num}`
            ];
            if (element.remark && element.remark != '') {
                food.push(`[备注：${element.remark}]`);
            }
            mainList.push(food);
        });
        printObj['mainList'] = mainList;
        printObj['secMainTitle'] = '';
        printObj['secMainFieldList'] = [];
        printObj['secMainList'] = [];
        printObj['thrMainTitle'] = '';
        printObj['thrMainFieldList'] = [];
        printObj['thrMainList'] = [];
        printObj['customContent'] = [];
        printObj['customFont'] = 'medium';
        printObj['footerFieldList'] = ['寄存人：', '手机号：'];
        printObj['footerTitleList'] = [data.data.username, data.data.userphone];
        if (data.data.validity_time && data.data.validity_time != '') {
            printObj['footerFieldList'].push('有效期：');
            printObj['footerTitleList'].push(data.data.validity_time);
        }
        printObj['bottomContent'] = '';
        printObj['isCutPage'] = '1';
        printObj['make'] = data.data.remark && data.data.remark != '' ? `备注：${data.data.remark}` : '';
        printObj['is_deposit'] = '1';

        arr.push(printObj);
    }

    return arr;
}

function getHcFoodsTemp(data, mergeType) {
    let arr = [];
    if (mergeType == 0 || mergeType == 1) { // 一菜一单
        for (let i = 0; i < data.foodsList.length; i++) {
            const element = data.foodsList[i];
            let hcPrintObj = {}
            hcPrintObj['shopName'] = '';
            hcPrintObj['pageTitle'] = data.isReprint == 2 ? '【分菜单补打】' : '【分菜单】';
            hcPrintObj['printType'] = '2';
            hcPrintObj['headerFieldList'] = [`${data.order_type}:`, "下单时间：", "订单单号："];
            hcPrintObj['headerTitleList'] = [];
            if (data.meal_type == 1) {
                hcPrintObj['headerTitleList'] = [data.desk_num || data.num, data.create_time || '', data.orderNum];
            } else {
                let pack_or_dineIn_text = ``;
                if (data.pack_or_dineIn == 1) { // 打包
                    pack_or_dineIn_text = '(打包)'
                } else if (data.pack_or_dineIn == 2) { // 堂食
                    pack_or_dineIn_text = '(堂食)'
                }
                if (data.order_type_index == 1 || data.order_type_index == 2) {
                    hcPrintObj['headerTitleList'] = [`${data.serial_number}${pack_or_dineIn_text}`, data.date + ' ' + data.time, data.orderNum];
                } else {
                    hcPrintObj['headerTitleList'] = [`${data.pick_order_num}${pack_or_dineIn_text}`, data.date + ' ' + data.time, data.orderNum];
                }
            }

            hcPrintObj['customList'] = [];

            hcPrintObj['mainFieldList'] = [];
            hcPrintObj['mainList'] = [];

            hcPrintObj['secMainTitle'] = '';
            hcPrintObj['secMainFieldList'] = [];
            hcPrintObj['secMainList'] = [];

            hcPrintObj["thrMainTitle"] = ""; //打印标题2-可选  价格明细
            hcPrintObj["thrMainFieldList"] = [];
            hcPrintObj["thrMainList"] = [];

            let mainList = [];
            if (element.spec_attr_name && element.spec_attr_name != '' && element.food_spec_fake != 1) {
                mainList = [`${element.food_name}`, `${element.food_num.toString()}${element.type == 1 || element.food_type == 1 ? (element.unit_name || '份') : ''}`, `【${element.spec_attr_name}】`];
            } else {
                mainList = [element.food_name, `${element.food_num.toString()}${element.type == 1 || element.food_type == 1 ? (element.unit_name || '份') : ''}`];
            }
            hcPrintObj['customContent'] = [mainList];
            hcPrintObj['customFont'] = 'medium'; // normal,medium,big

            hcPrintObj["footerFieldList"] = [];
            hcPrintObj["footerTitleList"] = [];
            if (data.remark || data.order_remark) {
                hcPrintObj["footerFieldList"] = ['备注：'];
                hcPrintObj["footerTitleList"] = [data.remark || data.order_remark];
            }

            hcPrintObj['bottomContent'] = '';

            hcPrintObj['isCutPage'] = store.state.isCutPage; // 是否切纸 0不切 1切纸

            arr.push(hcPrintObj);
        }
    } else if (mergeType == 2) { // 多菜一单
        let hcPrintObj = {}
        hcPrintObj['shopName'] = '';
        hcPrintObj['pageTitle'] = data.isReprint == 2 ? '【☆总菜单补打】' : '【☆总菜单】';
        hcPrintObj['printType'] = '2';
        hcPrintObj['headerFieldList'] = [`${data.order_type}:`, "下单时间：", "订单单号："];
        hcPrintObj['headerTitleList'] = [];
        if (data.meal_type == 1) {
            hcPrintObj['headerTitleList'] = [data.desk_num || data.num, data.create_time || '', data.orderNum];
        } else {
            let pack_or_dineIn_text = ``;
            if (data.pack_or_dineIn == 1) { // 打包
                pack_or_dineIn_text = '(打包)'
            } else if (data.pack_or_dineIn == 2) { // 堂食
                pack_or_dineIn_text = '(堂食)'
            }
            if (data.order_type_index == 1 || data.order_type_index == 2) {
                hcPrintObj['headerTitleList'] = [`${data.serial_number}${pack_or_dineIn_text}`, data.date + ' ' + data.time, data.orderNum];
            } else {
                hcPrintObj['headerTitleList'] = [`${data.pick_order_num}${pack_or_dineIn_text}`, data.date + ' ' + data.time, data.orderNum];
            }
        }

        hcPrintObj['customList'] = [];

        hcPrintObj['mainFieldList'] = [];
        hcPrintObj['mainList'] = [];

        hcPrintObj['secMainTitle'] = '';
        hcPrintObj['secMainFieldList'] = [];
        hcPrintObj['secMainList'] = [];

        hcPrintObj["thrMainTitle"] = ""; //打印标题2-可选  价格明细
        hcPrintObj["thrMainFieldList"] = [];
        hcPrintObj["thrMainList"] = [];

        let customContent = [];
        for (let i = 0; i < data.foodsList.length; i++) {
            let mainList = [];
            const element = data.foodsList[i];
            if (element.spec_attr_name && element.spec_attr_name != '' && element.food_spec_fake != 1) {
                mainList = [`${element.food_name}`, `${element.food_num.toString()}${element.type == 1 || element.food_type == 1 ? (element.unit_name || '份') : ''}`, `【${element.spec_attr_name}】`];
            } else {
                mainList = [`${element.food_name}`, `${element.food_num.toString()}${element.type == 1 || element.food_type == 1 ? (element.unit_name || '份') : ''}`];
            }
            customContent.push(mainList);
        }
        hcPrintObj['customContent'] = customContent;
        hcPrintObj['customFont'] = 'medium'; // normal,medium,big

        hcPrintObj["footerFieldList"] = [];
        hcPrintObj["footerTitleList"] = [];
        if (data.remark || data.order_remark) {
            hcPrintObj["footerFieldList"] = ['备注：'];
            hcPrintObj["footerTitleList"] = [data.remark || data.order_remark];
        }

        hcPrintObj['bottomContent'] = '';

        hcPrintObj['isCutPage'] = store.state.isCutPage; // 是否切纸 0不切 1切纸

        arr.push(hcPrintObj);
    }
    return arr;
}

export function editTipsStatus(type, order_id) {
    let query = new FormData();
    query.append('type', type);
    query.append('order_id', order_id)
    api.editTipStatus(query);
}

// 价格单位换算
export function priceUnitConversion(price, unit) {
    let p = 0; // 换算后的价格，￥X/千克
    if (unit == '千克' || unit.toUpperCase() == 'KG') {
        p = price;
    } else if (unit == '克' || unit.toUpperCase() == 'G') {
        p = price * 1000;
    } else if (unit == '斤' || unit.toUpperCase() == 'CA') {
        p = price * 100 * 2 / 100;
    }
    return p;
}

// 计重单位换算 电子秤计重单位是千克，根据传入的单位相应换算
export function weightUnitConversion(weight, unit) {
    let w = 0; // 换算后的计重，X${unit}
    if (unit == '千克' || unit.toUpperCase() == 'KG') {
        w = weight;
    } else if (unit == '克' || unit.toUpperCase() == 'G') {
        w = weight * 1000;
    } else if (unit == '斤' || unit.toUpperCase() == 'CA') {
        w = parseFloat(weight * 100 * 2 / 100).toFixed(3);
    }
    return w;
}

export function datetimePickerFormatter(type, val) {
    if (type === 'year') {
        return val + '年';
    }
    if (type === 'month') {
        return val + '月';
    }
    if (type === 'day') {
        return val + '日';
    }
    if (type === 'hour') {
        return val + '时'
    }
    if (type === 'minute') {
        return val + '分'
    }
    return val;
}

// 暂时没用
export function labelPrintFif(data) {
    // console.log('-------', data.labelFoods);
    let labelArr = [];
    let labelFoods = data.labelFoods;
    for (let i = 0; i < labelFoods.length; i++) {
        const element = labelFoods[i];
        // element.cloud_sn = element.cloud_sn && element.cloud_sn > 0 ? element.cloud_sn : '';
        if (element.ip && element.ip != '') {
            if (labelArr.findIndex(e => e.ip == element.ip) == -1) {
                const fdata = Object.assign({}, data, {ip: element.ip, size: element.size, labelFoods: []})
                data.labelFoods = [];
                labelArr.push(fdata);
            }
        } else {

        }
    }
    for (let j = 0; j < labelFoods.length; j++) {
        const ele = labelFoods[j];
        for (let i = 0; i < ipArr.length; i++) {
            const element = ipArr[i];
            if (ele.ip && element.ip == ele.ip) {
                element.labelFoods.push(ele)
            } else {

            }
        }
    }
    return ipArr;
}

// 更新对应系统打印机信息
export function updatePrinterInfo(data, type, printer_address) {
    // console.log('updatePrinterInfo', data, type, printer_address);
    let params = new FormData();
    for (const key in data) {
        if (Object.hasOwnProperty.call(data, key)) {
            params.append(key, data[key]);
        }
    }
    params.append('printer_address', printer_address);
    params.append('type', type); // 类型 1，前台打印机  2，后厨打印机 3标签打印机

    api.editPrinter(params).then(res => {
        // console.log('修改editPrinter', res);
    })
}

// 只针对前台打印机为USB打印机，在检测到前台USB打印连接正常后，检测标签打印机连接情况
export async function checkLabelAfterF() {
    if (localStorage.printType == 1) {
        // 设置了前台USB打印机
        if (store.state.bindStatus == 1) {
            const tagR = await checkUsbConnect();
            if (tagR.code == 1) {
                checkLabelPrint();
            }
        } else { // 没设置前台usb打印机
            checkLabelPrint();
        }
    }
}

export function addFoodPrintLog_global(data, is_print, printdata) {
    const logP = new FormData();
    logP.append('order_id', data.oid || data.order_id); // 订单ID
    logP.append('print_id', data.print_id); // 打印设置ID
    logP.append('content', JSON.stringify(printdata)); // 打印内容 使用 json 字符串
    logP.append('is_print', is_print); // 是否打印 1 是 0否
    let print_type = '';
    if (data.order_type_index == 1) { // 桌位订单
        print_type = '1';
    } else if (data.order_type_index == 2) { // 流水订单
        print_type = '4';
    } else if (data.order_type_index == 3) { // 自取订单
        print_type = '3';
    } else if (data.order_type_index == 4) { // 外卖订单
        print_type = '4';
    }
    logP.append('print_type', print_type); // 打印类型: 1 扫码点餐，2 外卖，3 自取, 4 流水单
    let print_source = '0';
    logP.append('print_source', print_source); // 打印来源  1：小程序，2 服务员,3 收银端
    logP.append('print_ip', data.ip); // 打印IP
    logP.append('print_size', data.size); // 打印IP
    api.addFoodPrintLog(logP).then(() => {
        store.commit('updateReprintHcFoodRefresh', true);
    }).catch(() => {
        store.commit('updateReprintHcFoodRefresh', true);
    });
}

export function setFoodPrintLog_global(food_print_id) {
    const logP = new FormData();
    logP.append('food_print_id', food_print_id); // 日志ID
    api.setFoodPrintLog(logP).then(res => {
        store.commit('updateReprintHcFoodRefresh', true);
    }).catch(() => {
        store.commit('updateReprintHcFoodRefresh', true);
    });
}

export function addTestPrintLog_global(data, is_print, printdata) {
    const logParams = new FormData();
    logParams.append('is_print', is_print); // is_print 是否打印 1 是 0否
    logParams.append('print_id', data.print_id);
    logParams.append('print_content', JSON.stringify(printdata));
    api.addTestPrintLog(logParams)
}

export async function checkIosLabelPrint() {
    // console.log('checkIosLabelPrint');
    const tag_printer = store.state.tagPrinter;
    // console.log('checkIosLabelPrint tag_printer', tag_printer);
    setTimeout(async () => {
        if (tag_printer.length > 0 && tag_printer.length > 0 && tag_printer[0].printer_type == '3') {
            const tagRes = await getBleConnectStatus();
            // console.log('tagRes, iOS', tagRes);
            if (tagRes.code != 1) {
                for (let i = 0; i < tag_printer.length; i++) {
                    const element = tag_printer[i];
                    connectAutoLabelBlue(element); // iOS，蓝牙
                }
            }
        }
    }, 500);
}

export function getAccountInfo(name) {
    if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');//这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split('=');//再次切割
            //判断查找相对应的值
            if (arr2[0] == name) {
                return arr2[1];
            }
        }
    }
}

export function getPayWayFromCode(code) {
    let way = '';
    let pay_code = code.substr(0, 2);
    // console.log(pay_code);
    // 微信付款码规则：18位纯数字，前缀以10、11、12、13、14、15开头
    if (10 <= pay_code && pay_code <= 15) {
        way = '1';
    } else if (25 <= pay_code && pay_code <= 30) { // 支付宝付款码规则：25~30开头的长度为16~24位的数字，实际字符串长度以开发者获取的付款码长度为准
        way = '2';
    } else if (pay_code > 50) {
        way = '4';
    }
    return way;
}

export function getPageOptions(limit, totalcount) {
    let arr = [];
    let total_pages = Math.ceil(totalcount / limit);
    for (let i = 0; i < total_pages; i++) {
        arr.push({
            text: `${i + 1}/${total_pages}`,
            value: i + 1,
        })
    }
    return arr;
}

// 计算库存差值
export function getDifference(all_food, food_num, type) {
    console.log('food_num', food_num);
    return new Promise((resolve, reject) => {
        let not_stock = 0;
        for (let i = 0; i < all_food.length; i++) {
            const element = all_food[i];
            let difference = 0;
            if (element.info && element.info.is_stock == 1) {
                if (element.info.is_spec == 1 && element.info.spec) {
                    difference = element.info.spec.stock * 1 - (element.num * food_num * 1);
                } else {
                    difference = element.info.stock * 1 - (element.num * food_num * 1);
                }
                console.log('difference', difference);
                if ((!type && difference < 0) || (type == 1 && difference <= 0)) {
                    Toast(`${element.name}${element.attr && element.attr != '' ? element.attr : ''}库存不足`);
                    not_stock++;
                }
            }
        }
        if (not_stock > 0) {
            resolve({code: 2, msg: '库存不足'});
        } else {
            resolve({code: 1, msg: '通过'});
        }
    })
}

export default {
    formatTimeWitchLine,
    tagKiller,
    printTest,
    _isInApp,
    randomString,
    _typeofEnv,
    getBeforeDate,
    netPrintSend,
    menuPrintFif,
    checkPrintType,
    getPrinterType,
    printTestReturnMenu,
    winPrintSend,
    formatTime,
    outPrintdataProcess,
    printTestDaily,
}



// WEBPACK FOOTER //
// ./src/utils/util.js